import {LocaleInfoModel} from "../../components/localization/interface";

const LocaleInfo: LocaleInfoModel[] = [
    {
        languageCode: 'az',
        locale: 'az-Latn-AZ',
        name: 'Azərbaycanca',
        icon: 'az',
        countryCode: 'AZ',
        localeDateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
        localeShortDateTimeFormat: 'DD.MM.YYYY HH:mm',
        localeDateFormat: 'DD.MM.YYYY',
        timeFormat: 'HH:mm:ss',
        rtl: false,
        displayLanguage: 'Azərbaycan'
    },
    {
        languageCode: 'en',
        locale: 'en-US',
        name: 'English',
        icon: 'us',
        countryCode: 'US',
        localeDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
        localeShortDateTimeFormat: 'YYYY-MM-DD HH:mm',
        localeDateFormat: 'MM/DD/YYYY',
        timeFormat: 'HH:mm:ss',
        rtl: false,
        displayLanguage: 'English'
    },
    {
        languageCode: 'tr',
        locale: 'tr-TR',
        name: 'Türkçe',
        icon: 'tr',
        countryCode: 'TR',
        localeDateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
        localeShortDateTimeFormat: 'DD.MM.YYYY HH:mm',
        localeDateFormat: 'DD.MM.YYYY',
        timeFormat: 'HH:mm:ss',
        rtl: false,
        displayLanguage: 'Türkçe'
    },
    {
        languageCode: 'uz',
        locale: 'uz-Latn-UZ',
        name: 'Oʻzbek',
        icon: 'uz',
        countryCode: 'UZ',
        localeDateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
        localeShortDateTimeFormat: 'DD.MM.YYYY HH:mm',
        localeDateFormat: 'DD.MM.YYYY',
        timeFormat: 'HH:mm:ss',
        rtl: false,
        displayLanguage: 'Oʻzbek'
    },
    {
        languageCode: 'ru',
        locale: 'ru-RU',
        name: 'Pусский',
        icon: 'ru',
        countryCode: 'RU',
        localeDateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
        localeShortDateTimeFormat: 'DD.MM.YYYY HH:mm',
        localeDateFormat: 'DD.MM.YYYY',
        timeFormat: 'HH:mm:ss',
        rtl: false,
        displayLanguage: 'Русский'
    },
    {
        languageCode: 'ar',
        locale: 'ar-QA',
        name: 'العربية',
        icon: 'qa',
        countryCode: 'QA',
        localeDateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
        localeShortDateTimeFormat: 'DD/MM/YYYY HH:mm',
        localeDateFormat: 'DD/MM/YYYY',
        timeFormat: 'HH:mm:ss',
        rtl: true,
        displayLanguage: 'العربية'
    }
];

export default LocaleInfo;
